import { AccountRole } from '@core/models/account/account-role';
import { DeliveryOrderExportType } from '@core/models/delivery/delivery-order-export-type';
import { DeliveryOrderStatus } from '@core/models/delivery/delivery-order-status';
import { OrderType } from '@core/models/delivery/order-type';
import { DateFilterRangeShortcut } from '@core/models/filter/date-filter-range-shorcut';
import { IListFilterState } from '@core/state/shared/list/list-filter-state';
import { FORMAT } from '@core/utils/formats';
import { MOMENT_UNIT } from '@core/utils/moment';
import * as moment from 'moment';

export interface IDeliveryOrdersFilterState extends IListFilterState {
    roles?: AccountRole[];
    order_type?: OrderType;
    export_type?: DeliveryOrderExportType;
    status?: DeliveryOrderStatus[];
    refund_status?: string[];
    tracking_ids?: string[];
}

export const initialDeliveryOrdersFiltersState: IDeliveryOrdersFilterState = {
    locations: [],
    order_type: OrderType.DELIVERY,
    status: [
        DeliveryOrderStatus.NEW,
        DeliveryOrderStatus.ACCEPTED,
        DeliveryOrderStatus.ASSIGNED,
        DeliveryOrderStatus.PICKUP,
        DeliveryOrderStatus.DROPOFF,
        DeliveryOrderStatus.REJECTED,
        DeliveryOrderStatus.RETURNING,
        DeliveryOrderStatus.SCHEDULED,
    ],
    rangeShortcut: DateFilterRangeShortcut.TODAY,
    start: moment().startOf(MOMENT_UNIT.DAYS).format(FORMAT.DATETIME_SERVER),
    end: moment().endOf(MOMENT_UNIT.DAYS).format(FORMAT.DATETIME_SERVER),
};